import React from "react";
import { FichasData } from "../../../data/fichas.data";

interface Props {
  car: any;
  showGalleryMenu: boolean;
  setShowGaleryMenu: (boolean: any) => void;
  setShowPDFMenu: (value: boolean) => void
}

const SidebarFooter: React.FC<Props> = ({ car, showGalleryMenu, setShowGaleryMenu, setShowPDFMenu}) => {

  const [ficha, setFicha] = React.useState<any>(null);
  React.useEffect(() => {
      const fichasData: any = FichasData();
      setFicha(fichasData[car.id]);
    }, [car]);
  
    const openURL = (url: string) => {
      window.open(url, "_blank", "noopener,noreferrer");
    };

  return (
    <div className="studio-sidebar-options">
      {showGalleryMenu &&
      <div className='studio-sidebar-options-button' onClick={() => {setShowGaleryMenu(false)}}>
        <div className='studio-sidebar-options-text'>Salir de galería</div>
      </div>
      }

      {!showGalleryMenu &&
      <div className='studio-sidebar-options-button' onClick={() => {setShowGaleryMenu(true)}}>
        <div className='studio-sidebar-options-text'>Galería</div>
      </div>
      }
      {!showGalleryMenu &&
      <div className='studio-sidebar-options-button' onClick={() => {openURL(ficha.url_video)}}>
        <div className='studio-sidebar-options-text'>Video</div>
      </div>
      }
      {!showGalleryMenu &&
      <div className='studio-sidebar-options-button' onClick={() => {openURL(ficha.url_catalog)}}>
        <div className='studio-sidebar-options-text'>Ficha Técnica</div>
      </div>
      }
      {!showGalleryMenu &&
      <div className='studio-sidebar-options-button av-btn-primary' onClick={() => {openURL(ficha.url_cotiza)}}>
        <div className='studio-sidebar-options-text'>Cotiza este vehículo</div>
      </div>
      }
    </div>
  );
};

export default SidebarFooter;